import { getCurrentUser as c, getRequestToken as x } from "@nextcloud/auth";
import { getLoggerBuilder as m } from "@nextcloud/logger";
import { getCanonicalLocale as N } from "@nextcloud/l10n";
import { join as R, basename as A, extname as F, dirname as d } from "path";
import { generateRemoteUrl as g } from "@nextcloud/router";
import { createClient as S, getPatcher as $ } from "webdav";
import { request as P } from "webdav/dist/node/request.js";
const B = (e) => e === null ? m().setApp("files").build() : m().setApp("files").setUid(e.uid).build(), a = B(c());
class L {
  _entries = [];
  registerEntry(t) {
    this.validateEntry(t), this._entries.push(t);
  }
  unregisterEntry(t) {
    const r = typeof t == "string" ? this.getEntryIndex(t) : this.getEntryIndex(t.id);
    if (r === -1) {
      a.warn("Entry not found, nothing removed", { entry: t, entries: this.getEntries() });
      return;
    }
    this._entries.splice(r, 1);
  }
  getEntries(t) {
    return t ? this._entries.filter((r) => typeof r.if == "function" ? r.if(t) : !0) : this._entries;
  }
  getEntryIndex(t) {
    return this._entries.findIndex((r) => r.id === t);
  }
  validateEntry(t) {
    if (!t.id || !t.displayName || !(t.iconSvgInline || t.iconClass))
      throw new Error("Invalid entry");
    if (typeof t.id != "string" || typeof t.displayName != "string")
      throw new Error("Invalid id or displayName property");
    if (t.iconClass && typeof t.iconClass != "string" || t.iconSvgInline && typeof t.iconSvgInline != "string")
      throw new Error("Invalid icon provided");
    if (t.if !== void 0 && typeof t.if != "function")
      throw new Error("Invalid if property");
    if (t.templateName && typeof t.templateName != "string")
      throw new Error("Invalid templateName property");
    if (t.handler && typeof t.handler != "function")
      throw new Error("Invalid handler property");
    if (!t.templateName && !t.handler)
      throw new Error("At least a templateName or a handler must be provided");
    if (this.getEntryIndex(t.id) !== -1)
      throw new Error("Duplicate entry");
  }
}
const p = function() {
  return typeof window._nc_newfilemenu > "u" && (window._nc_newfilemenu = new L(), a.debug("NewFileMenu initialized")), window._nc_newfilemenu;
}, l = ["B", "KB", "MB", "GB", "TB", "PB"], u = ["B", "KiB", "MiB", "GiB", "TiB", "PiB"];
function J(e, t = !1, r = !1) {
  typeof e == "string" && (e = Number(e));
  let n = e > 0 ? Math.floor(Math.log(e) / Math.log(r ? 1024 : 1e3)) : 0;
  n = Math.min((r ? u.length : l.length) - 1, n);
  const s = r ? u[n] : l[n];
  let i = (e / Math.pow(r ? 1024 : 1e3, n)).toFixed(1);
  return t === !0 && n === 0 ? (i !== "0.0" ? "< 1 " : "0 ") + (r ? u[1] : l[1]) : (n < 2 ? i = parseFloat(i).toFixed(0) : i = parseFloat(i).toLocaleString(N()), i + " " + s);
}
class Q {
  _action;
  constructor(t) {
    this.validateAction(t), this._action = t;
  }
  get id() {
    return this._action.id;
  }
  get displayName() {
    return this._action.displayName;
  }
  get iconSvgInline() {
    return this._action.iconSvgInline;
  }
  get enabled() {
    return this._action.enabled;
  }
  get exec() {
    return this._action.exec;
  }
  get execBatch() {
    return this._action.execBatch;
  }
  get order() {
    return this._action.order;
  }
  get default() {
    return this._action.default;
  }
  get inline() {
    return this._action.inline;
  }
  get renderInline() {
    return this._action.renderInline;
  }
  validateAction(t) {
    if (!t.id || typeof t.id != "string")
      throw new Error("Invalid id");
    if (!t.displayName || typeof t.displayName != "function")
      throw new Error("Invalid displayName function");
    if (!t.iconSvgInline || typeof t.iconSvgInline != "function")
      throw new Error("Invalid iconSvgInline function");
    if (!t.exec || typeof t.exec != "function")
      throw new Error("Invalid exec function");
    if ("enabled" in t && typeof t.enabled != "function")
      throw new Error("Invalid enabled function");
    if ("execBatch" in t && typeof t.execBatch != "function")
      throw new Error("Invalid execBatch function");
    if ("order" in t && typeof t.order != "number")
      throw new Error("Invalid order");
    if ("default" in t && typeof t.default != "boolean")
      throw new Error("Invalid default");
    if ("inline" in t && typeof t.inline != "function")
      throw new Error("Invalid inline function");
    if ("renderInline" in t && typeof t.renderInline != "function")
      throw new Error("Invalid renderInline function");
  }
}
const X = function(e) {
  if (typeof window._nc_fileactions > "u" && (window._nc_fileactions = [], a.debug("FileActions initialized")), window._nc_fileactions.find((t) => t.id === e.id)) {
    a.error(`FileAction ${e.id} already registered`, { action: e });
    return;
  }
  window._nc_fileactions.push(e);
}, Y = function() {
  return window._nc_fileactions || [];
};
class Z {
  _header;
  constructor(t) {
    this.validateHeader(t), this._header = t;
  }
  get id() {
    return this._header.id;
  }
  get order() {
    return this._header.order;
  }
  get enabled() {
    return this._header.enabled;
  }
  get render() {
    return this._header.render;
  }
  get updated() {
    return this._header.updated;
  }
  validateHeader(t) {
    if (!t.id || !t.render || !t.updated)
      throw new Error("Invalid header: id, render and updated are required");
    if (typeof t.id != "string")
      throw new Error("Invalid id property");
    if (t.enabled !== void 0 && typeof t.enabled != "function")
      throw new Error("Invalid enabled property");
    if (t.render && typeof t.render != "function")
      throw new Error("Invalid render property");
    if (t.updated && typeof t.updated != "function")
      throw new Error("Invalid updated property");
  }
}
const ee = function(e) {
  if (typeof window._nc_filelistheader > "u" && (window._nc_filelistheader = [], a.debug("FileActions initialized")), window._nc_filelistheader.find((t) => t.id === e.id)) {
    a.error(`Header ${e.id} already registered`, { header: e });
    return;
  }
  window._nc_filelistheader.push(e);
}, te = function() {
  return window._nc_filelistheader || [];
};
var o = ((e) => (e[e.NONE = 0] = "NONE", e[e.CREATE = 4] = "CREATE", e[e.READ = 1] = "READ", e[e.UPDATE = 2] = "UPDATE", e[e.DELETE = 8] = "DELETE", e[e.SHARE = 16] = "SHARE", e[e.ALL = 31] = "ALL", e))(o || {});
const _ = ["d:getcontentlength", "d:getcontenttype", "d:getetag", "d:getlastmodified", "d:quota-available-bytes", "d:resourcetype", "nc:has-preview", "nc:is-encrypted", "nc:mount-type", "nc:share-attributes", "oc:comments-unread", "oc:favorite", "oc:fileid", "oc:owner-display-name", "oc:owner-id", "oc:permissions", "oc:share-types", "oc:size", "ocs:share-permissions"], y = { d: "DAV:", nc: "http://nextcloud.org/ns", oc: "http://owncloud.org/ns", ocs: "http://open-collaboration-services.org/ns" }, re = function(e, t = { nc: "http://nextcloud.org/ns" }) {
  typeof window._nc_dav_properties > "u" && (window._nc_dav_properties = [..._], window._nc_dav_namespaces = { ...y });
  const r = { ...window._nc_dav_namespaces, ...t };
  if (window._nc_dav_properties.find((s) => s === e))
    return a.error(`${e} already registered`, { prop: e }), !1;
  if (e.startsWith("<") || e.split(":").length !== 2)
    return a.error(`${e} is not valid. See example: 'oc:fileid'`, { prop: e }), !1;
  const n = e.split(":")[0];
  return r[n] ? (window._nc_dav_properties.push(e), window._nc_dav_namespaces = r, !0) : (a.error(`${e} namespace unknown`, { prop: e, namespaces: r }), !1);
}, h = function() {
  return typeof window._nc_dav_properties > "u" && (window._nc_dav_properties = [..._]), window._nc_dav_properties.map((e) => `<${e} />`).join(" ");
}, f = function() {
  return typeof window._nc_dav_namespaces > "u" && (window._nc_dav_namespaces = { ...y }), Object.keys(window._nc_dav_namespaces).map((e) => `xmlns:${e}="${window._nc_dav_namespaces?.[e]}"`).join(" ");
}, M = function() {
  return `<?xml version="1.0"?>
		<d:propfind ${f()}>
			<d:prop>
				${h()}
			</d:prop>
		</d:propfind>`;
}, T = function() {
  return `<?xml version="1.0"?>
		<oc:filter-files ${f()}>
			<d:prop>
				${h()}
			</d:prop>
			<oc:filter-rules>
				<oc:favorite>1</oc:favorite>
			</oc:filter-rules>
		</oc:filter-files>`;
}, ie = function(e) {
  return `<?xml version="1.0" encoding="UTF-8"?>
<d:searchrequest ${f()}
	xmlns:ns="https://github.com/icewind1991/SearchDAV/ns">
	<d:basicsearch>
		<d:select>
			<d:prop>
				${h()}
			</d:prop>
		</d:select>
		<d:from>
			<d:scope>
				<d:href>/files/${c()?.uid}/</d:href>
				<d:depth>infinity</d:depth>
			</d:scope>
		</d:from>
		<d:where>
			<d:and>
				<d:or>
					<d:not>
						<d:eq>
							<d:prop>
								<d:getcontenttype/>
							</d:prop>
							<d:literal>httpd/unix-directory</d:literal>
						</d:eq>
					</d:not>
					<d:eq>
						<d:prop>
							<oc:size/>
						</d:prop>
						<d:literal>0</d:literal>
					</d:eq>
				</d:or>
				<d:gt>
					<d:prop>
						<d:getlastmodified/>
					</d:prop>
					<d:literal>${e}</d:literal>
				</d:gt>
			</d:and>
		</d:where>
		<d:orderby>
			<d:order>
				<d:prop>
					<d:getlastmodified/>
				</d:prop>
				<d:descending/>
			</d:order>
		</d:orderby>
		<d:limit>
			<d:nresults>100</d:nresults>
			<ns:firstresult>0</ns:firstresult>
		</d:limit>
	</d:basicsearch>
</d:searchrequest>`;
}, z = function(e = "") {
  let t = o.NONE;
  return e && ((e.includes("C") || e.includes("K")) && (t |= o.CREATE), e.includes("G") && (t |= o.READ), (e.includes("W") || e.includes("N") || e.includes("V")) && (t |= o.UPDATE), e.includes("D") && (t |= o.DELETE), e.includes("R") && (t |= o.SHARE)), t;
};
var w = ((e) => (e.Folder = "folder", e.File = "file", e))(w || {});
const E = function(e, t) {
  return e.match(t) !== null;
}, v = (e, t) => {
  if (e.id && typeof e.id != "number")
    throw new Error("Invalid id type of value");
  if (!e.source)
    throw new Error("Missing mandatory source");
  try {
    new URL(e.source);
  } catch {
    throw new Error("Invalid source format, source must be a valid URL");
  }
  if (!e.source.startsWith("http"))
    throw new Error("Invalid source format, only http(s) is supported");
  if (e.mtime && !(e.mtime instanceof Date))
    throw new Error("Invalid mtime type");
  if (e.crtime && !(e.crtime instanceof Date))
    throw new Error("Invalid crtime type");
  if (!e.mime || typeof e.mime != "string" || !e.mime.match(/^[-\w.]+\/[-+\w.]+$/gi))
    throw new Error("Missing or invalid mandatory mime");
  if ("size" in e && typeof e.size != "number" && e.size !== void 0)
    throw new Error("Invalid size type");
  if ("permissions" in e && e.permissions !== void 0 && !(typeof e.permissions == "number" && e.permissions >= o.NONE && e.permissions <= o.ALL))
    throw new Error("Invalid permissions");
  if (e.owner && e.owner !== null && typeof e.owner != "string")
    throw new Error("Invalid owner type");
  if (e.attributes && typeof e.attributes != "object")
    throw new Error("Invalid attributes type");
  if (e.root && typeof e.root != "string")
    throw new Error("Invalid root type");
  if (e.root && !e.root.startsWith("/"))
    throw new Error("Root must start with a leading slash");
  if (e.root && !e.source.includes(e.root))
    throw new Error("Root must be part of the source");
  if (e.root && E(e.source, t)) {
    const r = e.source.match(t)[0];
    if (!e.source.includes(R(r, e.root)))
      throw new Error("The root must be relative to the service. e.g /files/emma");
  }
};
class b {
  _data;
  _attributes;
  _knownDavService = /(remote|public)\.php\/(web)?dav/i;
  constructor(t, r) {
    v(t, r || this._knownDavService), this._data = t;
    const n = { set: (s, i, D) => (this.updateMtime(), Reflect.set(s, i, D)), deleteProperty: (s, i) => (this.updateMtime(), Reflect.deleteProperty(s, i)) };
    this._attributes = new Proxy(t.attributes || {}, n), delete this._data.attributes, r && (this._knownDavService = r);
  }
  get source() {
    return this._data.source.replace(/\/$/i, "");
  }
  get basename() {
    return A(this.source);
  }
  get extension() {
    return F(this.source);
  }
  get dirname() {
    if (this.root) {
      const r = this.source.indexOf(this.root);
      return d(this.source.slice(r + this.root.length) || "/");
    }
    const t = new URL(this.source);
    return d(t.pathname);
  }
  get mime() {
    return this._data.mime;
  }
  get mtime() {
    return this._data.mtime;
  }
  get crtime() {
    return this._data.crtime;
  }
  get size() {
    return this._data.size;
  }
  get attributes() {
    return this._attributes;
  }
  get permissions() {
    return this.owner === null && !this.isDavRessource ? o.READ : this._data.permissions !== void 0 ? this._data.permissions : o.NONE;
  }
  get owner() {
    return this.isDavRessource ? this._data.owner : null;
  }
  get isDavRessource() {
    return E(this.source, this._knownDavService);
  }
  get root() {
    return this._data.root ? this._data.root.replace(/^(.+)\/$/, "$1") : this.isDavRessource && d(this.source).split(this._knownDavService).pop() || null;
  }
  get path() {
    if (this.root) {
      const t = this.source.indexOf(this.root);
      return this.source.slice(t + this.root.length) || "/";
    }
    return (this.dirname + "/" + this.basename).replace(/\/\//g, "/");
  }
  get fileid() {
    return this._data?.id || this.attributes?.fileid;
  }
  move(t) {
    v({ ...this._data, source: t }, this._knownDavService), this._data.source = t, this.updateMtime();
  }
  rename(t) {
    if (t.includes("/"))
      throw new Error("Invalid basename");
    this.move(d(this.source) + "/" + t);
  }
  updateMtime() {
    this._data.mtime && (this._data.mtime = /* @__PURE__ */ new Date());
  }
}
class q extends b {
  get type() {
    return w.File;
  }
}
class C extends b {
  constructor(t) {
    super({ ...t, mime: "httpd/unix-directory" });
  }
  get type() {
    return w.Folder;
  }
  get extension() {
    return null;
  }
  get mime() {
    return "httpd/unix-directory";
  }
}
const I = `/files/${c()?.uid}`, U = g("dav" + I), ne = function(e = U) {
  const t = S(e, { headers: { requesttoken: x() || "" } });
  return $().patch("request", (r) => (r.headers?.method && (r.method = r.headers.method, delete r.headers.method), P(r))), t;
}, oe = async (e, t = "/") => (await e.getDirectoryContents(t, { details: !0, data: t === "/" ? T() : M(), headers: { method: t === "/" ? "REPORT" : "PROPFIND" }, includeSelf: !0 })).data.filter((r) => r.filename !== t).map((r) => k(r)), k = function(e, t = I) {
  const r = e.props, n = z(r?.permissions), s = c()?.uid, i = { id: r?.fileid || 0, source: g(`dav${t}${e.filename}`), mtime: new Date(Date.parse(e.lastmod)), mime: e.mime, size: r?.size || 0, permissions: n, owner: s, root: t, attributes: { ...e, ...r, hasPreview: r?.["has-preview"] } };
  return delete i.attributes?.props, e.type === "file" ? new q(i) : new C(i);
}, se = function(e) {
  return p().registerEntry(e);
}, ae = function(e) {
  return p().unregisterEntry(e);
}, de = function(e) {
  return p().getEntries(e);
};
export {
  q as File,
  Q as FileAction,
  w as FileType,
  C as Folder,
  Z as Header,
  b as Node,
  o as Permission,
  se as addNewFileMenuEntry,
  U as davDefaultRootUrl,
  ne as davGetClient,
  M as davGetDefaultPropfind,
  T as davGetFavoritesReport,
  ie as davGetRecentSearch,
  z as davParsePermissions,
  k as davResultToNode,
  I as davRootPath,
  y as defaultDavNamespaces,
  _ as defaultDavProperties,
  J as formatFileSize,
  f as getDavNameSpaces,
  h as getDavProperties,
  oe as getFavoriteNodes,
  Y as getFileActions,
  te as getFileListHeaders,
  de as getNewFileMenuEntries,
  re as registerDavProperty,
  X as registerFileAction,
  ee as registerFileListHeaders,
  ae as removeNewFileMenuEntry
};
